import { RuleResult } from 'types/DeclarationP5'
import { removePrefix } from 'shared/ncts/common/classifier-util'

const C0531Validator = {
  validateBorderTransportMeansConveyanceReferenceNumberRequirement: ({
    security,
    borderModeOfTransport,
  }: {
    security: string
    borderModeOfTransport: string
  }): RuleResult => {
    if ((security === '1' || security === '2' || security === '3')
      && removePrefix(borderModeOfTransport, 'TRANSPORT_MODE_', 1) === '4') {
      return 'REQUIRED'
    }

    return 'OPTIONAL'
  },
} as const

export default C0531Validator
